




























































































import { Component, Vue } from "vue-property-decorator";
import { ContentTemplate } from "@/services/contentTemplates/types";
import { getContentTemplates } from "@/services/contentTemplates/contentTemplateService";
import i18n from "@/i18n";
import { selectContentTemplateFields } from "@/components/contentTemplates/fields/selectContentTemplateFields";
import { TagOption } from "@/services/tags/types";

    @Component
export default class SelectContentTemplateModal extends Vue {
    // local state
        contentTemplates = [] as Array<ContentTemplate>;
        fields = selectContentTemplateFields;
        isBusy = false;
        sortBy = "name";
        sortDesc = false;
        selectedContentTemplates = [] as ContentTemplate[];
        multiPicker = false;
        tagOptions = [] as TagOption[];
        // filter
        filterWidth = "" as string;
        filterHeight = "" as string;

        // filter options
        searchText = "" as string;
        // lifecycle hooks
        public created(): void {
            this.fetchData();
        }

        // computed
        get title(): string {
            return i18n.t("contentTemplates.selectContentTemplate").toString();
        }

        get model(): Array<ContentTemplate> {
            const selectedTags = this.tagOptions.filter(x => x.selected === true);
            return this.contentTemplates.filter(
                x =>
                    (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight) &&
                    (selectedTags.length > 0 ? selectedTags.every(tag => x.tags.some(y => y.id === tag.id)) : true)
            );
        }

        get filterActive(): boolean {
            return (this.searchText !== "" || this.filterWidth !== "" || this.filterHeight !== "");
        }

        // methods
        open(multiPicker = false) {
            this.multiPicker = multiPicker;
            this.fetchData();
            this.$bvModal.show("modal-selectContentTemplate");
        }

        fetchData() {
            this.loadContentTemplates();
        }

        loadContentTemplates() {
            this.isBusy = true;
            this.contentTemplates = [] as Array<ContentTemplate>;
            getContentTemplates().then(response => {
                this.contentTemplates = response;
                this.initTags();
                this.isBusy = false;
            });
        }

        initTags() {
            const allTags = this.contentTemplates.flatMap(x => x.tags);
            const uniqueTags = [...new Set(allTags.map(i => JSON.stringify(i)))].map(i => JSON.parse(i));
            const sortedTags = uniqueTags.sort(function (a, b) {
                const textA = a.name.toUpperCase();
                const textB = b.name.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.tagOptions = sortedTags.map(x => ({ id: x.id, name: x.name, selected: false } as TagOption));
        }

        rowSelected(items: ContentTemplate[]) {
            this.selectedContentTemplates = items;
        }

        save() {
            this.$bvModal.hide("modal-selectContentTemplate");

            if (!this.selectedContentTemplates || this.selectedContentTemplates.length === 0) {
                return;
            }

            this.$emit("select", this.selectedContentTemplates);
        }

        clearFilter() {
            this.filterWidth = "";
            this.filterHeight = "";
            this.loadContentTemplates();
        }

        resetState() {
            this.searchText = "";
            this.filterWidth = "";
            this.filterHeight = "";
            this.selectedContentTemplates = [] as ContentTemplate[];
        }

        typeDisplay(type: string) {
            if (type === "html") {
                return i18n.t("posts.Html");
            }
            if (type === "fixedhtml") {
                return i18n.t("posts.FixedHtml");
            }
            return type;
        }
}
